import React from 'react'
import BreadCrumb from './BreadCrumb';
import Footer from '../../components/footer/Footer';
import ShopAreas from './ShopArea';
import HeaderOne from '../../components/header/HeaderOne';
import ShopArea from '../../components/index/ShopArea';
function Shop() {
  return (
	<>
	 <HeaderOne/>
     <main>
	 	<BreadCrumb/>
		<ShopAreas/>
		<ShopArea/>
	 </main>
	 <Footer/>
	</>
  )
}

export default Shop